import type { KeepBody, SeedText } from "../api/start";
import { buildCardText, type FlowState } from "./startFlow";

export function buildKeepBody(flow: FlowState, seedText: SeedText, locale: string): KeepBody | null {
  if (!flow.seedId) return null;
  const angleTitle = flow.helpfulAngleId ? seedText.angles?.[flow.helpfulAngleId]?.title || "" : "";
  return {
    flowId: flow.flowId,
    seedId: flow.seedId,
    angleId: flow.helpfulAngleId || flow.seen[flow.seen.length - 1]?.angleId,
    cardText: buildCardText(flow, seedText, angleTitle),
    step: flow.step,
    src: flow.src,
    c: flow.c,
    locale,
  };
}
